/* eslint-disable no-unused-vars */
import React from 'react'
import FilterSection from 'components/molecules/FilterSection/FilterSection'
import HomeContent from 'components/organisms/HomeContent/HomeContent';
import PropTypes from 'prop-types';

function Home ({ setUploadModalVisibility, currentUserRole }) {
  return (
    <>
      <div className='home'>
        <FilterSection />
        <HomeContent />
      </div>
    </>
  )
}
Home.propTypes = {
  setUploadModalVisibility: PropTypes.function || PropTypes.any,
  currentUserRole: PropTypes.any
};
export default Home
